import { render, staticRenderFns } from "./tabelaRelatorio.vue?vue&type=template&id=f6988694"
import script from "./tabelaRelatorio.vue?vue&type=script&lang=js"
export * from "./tabelaRelatorio.vue?vue&type=script&lang=js"
import style0 from "./tabelaRelatorio.vue?vue&type=style&index=0&id=f6988694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports